/**
 *
 * @description 获取数据类型
 * @export
 * @returns {String}
 * 
 */
 export function getDataType(data) {
    return Object.prototype.toString.call(data).slice(8, -1)
}


/**
 *
 * @description 去掉数据中字符串收尾空格
 * @export
 * @returns {Object}
 * @example 
 * 
 *    dataTrim({a:{a: ' ttt ',b: [' ttt ']}) // {a:{a: 'ttt',b: ['ttt']}
 *    
 */
export function dataTrim(data) {
    const type = getDataType(data)
    let result = data
    if (type === 'Object' && !data.__URLSearchParams__) {
        result = {}
    }else if(type === 'Array'){
        result = []
    }
    else if(type === 'URLSearchParams' && Object.fromEntries){
        result = {}
        data = Object.fromEntries(data)
    }
    else{
        return result
    }
    for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
            const value = data[k]
            const t = getDataType(value)
            if (t === 'String') {
                result[k] = value.trim()
            }else if(t === 'Object' || t === 'Array'){
                result[k] = dataTrim(value)
            }else{
                result[k] = value
            }
        }
    }
    return result
}


// WEBPACK FOOTER //
// ./src/util/dataTrim.js